import { removeEmptyStringsOrHttpFromArray } from "@helpers/stringHelper";
import { UserAccountState } from "@store/userAccountSlice";
import { appInsights } from "../../AppInsights";

export const TrackPageView = (
    pageName: string,
    account: UserAccountState,
    userRoles: number[]
): { trackPageViewFunction: () => void } => {
    const trackPageViewFunction = (): void => {
        let displayPageName: string;

        const isUserLoggedIn = account.accounts && account.accounts.length > 0;

        if (pageName === "/") {
            displayPageName = "landing page";
        } else {
            const pageArray = removeEmptyStringsOrHttpFromArray(pageName.split("/"));
            displayPageName = pageArray.join("-");
        }

        appInsights.trackPageView({
            name: `${displayPageName}`,
            properties: {
                refUri: document.referrer,
                userRoles,
                isUserLoggedIn,
                isExternal: false
            }
        });
    };

    return { trackPageViewFunction };
};

export default TrackPageView;
